import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { server_address as proxy } from '../custom-modules/serverAddress';
import './styles/home.scss';


function Home() 
{
    const [id_input, set_id_input] = useState("");
    const [password_input, set_password_input] = useState("");
    const [error_text, set_error_text] = useState(false);

    const redirect = useNavigate();


    function setup_id_input(value)
    {
        if (value.includes("'") || value.includes('"') || value.includes("`")) return;
        set_id_input(value);
    }

    function setup_password_input(value)
    {
        if (value.includes("'") || value.includes('"') || value.includes("`")) return;
        set_password_input(value);
    }


    function sign_in()
    {
        let is_valid = true;
        let err_temp = "";
        set_error_text("");


        
        if (password_input.length < 8)
        {
            is_valid = false;
            err_temp = "Password should at least be 8 letters!";
        }
            
        if (id_input.length <= 0 || password_input.length <= 0)
        {
            is_valid = false;
            err_temp = "Please fill in the blanks!";
        }
            
        if (!is_valid)
        {
            set_error_text(err_temp);
            return;
        }



        axios.post(`${proxy}/verifySignIn`, { username: id_input, password: password_input })
            .then((res) => 
            {
                console.log(res.data)
                switch (res.data)
                {
                    case "err-nouser":
                        {
                            set_error_text("Cannot establish a connection with the server!");
                        }
                        break;

                    case "err-backend":
                        {
                            set_error_text("Cannot establish a connection with the server! (err-0013)");
                        }
                        break;

                    case "err-noaccess":
                        {
                            set_error_text("Cannot establish a connection with the server! (err-noaccess)");
                        }
                        break;

                    default:
                        {
                            localStorage.setItem("user-id", res.data);
                            redirect("/room1");
                        }
                        break;
                }
            })
            .catch((err) => console.error(err));
    }



  return (
    <div className="home-container">
        <div className="home-content-container">
            {/* <div>
                <h1>fuckyoubitch.com</h1> 
                <span>is available for sale!</span>
            </div> */}
            
                <div className="home-sale-info">
                    {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <strong>fuckyoubitch.com</strong>
                        <span>$259</span>
                    </div> 
                    <br /> */}
                    {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <strong>Privacy protecion</strong>
                        <span>Included</span>
                    </div> 
                    <hr />
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: "16px" }}>
                        <strong>Total</strong>
                        <span>$259</span>
                    </div> 
                    <br /> */}
                    <span>ID: </span> <br />
                    <input type="text" value={id_input} onInput={(e) => setup_id_input(e.target.value)} maxLength={16} /> 
                    <br /> <br />
                    <span>Password: </span> <br />
                    <input type="password" value={password_input} onInput={(e) => setup_password_input(e.target.value)} maxLength={50} />
                    <br />
                    <hr />
                    
                    <span className="error">{error_text}</span> <br />
                    <button className="btn" onClick={sign_in}>
                        <i class="fas fa-lock mr-2" style={{ fontSize: ".9em" }} aria-hidden="true"></i>
                        Enter
                    </button>
                </div> 
            
        </div>
    </div>
  );
}

export default Home;